<template>
  <div class="container">
      <Layout>
          <Row class="hint-img">
              <img src="../assets/image/img-activate.png"/>
          </Row>
          <Row>
              <div class="hint">
                  <p>{{text.name}}</p>
                  <P>{{$t('message.A_nonactivate_SNhint')}} {{text.batch_no}}</P>
              </div>
              <p class="text-cur">{{$t('message.A_activate_cur')}}</p>
              <p class="text-act">{{$t('message.A_activate_act')}}</p>
              <p class="text-cur margin-a-active">{{$t('message.A_activate_act_hint')}}{{hint}}</p>
              <p class="text-cur text-red">{{$t('message.A_activate_purchase')}}</p>
          </Row>
          <Row>
              <Button class="btn" long type="primary" @click="handleClick()">
                  {{$t('message.A_activate_report')}}
              </Button>
          </Row>
      </Layout>
  </div>
</template>

<script>
  export default {
      name: "A_activate",
      data() {
          return {
              text: {
                  name: '',
                  email: '',
                  device_uuid: ''
              },
              hint: ''
          }
      },
      created() {
          this.getText();
          this.hint = this.text.email == '' ?
              this.$t('message.A_activate_device') + this.text.device_uuid : this.$t('message.A_activate_email') + this.text.email;
          this.text.batch_no = this.prefixInteger(this.text.batch_no, 8);
      },
      methods: {
          handleClick() {
              this.$router.push({name: 'Inform'});
          },
          getText() {
              let _me = this;
              _me.text = _me.$route.params.data;
              if (_me.text == undefined) {
                  let list = sessionStorage.getItem("text");
                  _me.text = JSON.parse(list);
              } else {
                  sessionStorage.setItem("text", JSON.stringify(_me.text));
              }
          },
          prefixInteger(num, n) {
              return (Array(n).join(0) + num).slice(-n);
          },
      }
  }
</script>

<style scoped>
  .hint {
      margin: 0.4rem 0;
  }
  
  .btn {
      margin-top: 2.34rem;
  }
  
  .margin-a-active {
      margin-bottom: 0.6rem;
  }
  
  .text-red {
      color: #f64b49;
  }
</style>
